
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { ObjectType, SportType } from '@/@types/graphql-types';

@Component({ name: 'Header' })
export default class Header extends Vue {
	isExpanded = false;

	handleExpandClick() {
		this.isExpanded = !this.isExpanded;
		const sportType = this.$route.meta?.sport as SportType;
		const sportContext = new SnowplowSportContext(sportType, ObjectType.Sport);
		TrackingHelper.trackEvent('userinteraction', { action: 'read_more_clicked' }, [sportContext]);
	}
}
